import { OrganizationListManager } from "@/components/organization-list/OrganizationListManager.tsx";
import { Page } from "@skailer-com/uikit";
import { useTitle } from "@/hooks/use-title.hook.ts";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";
import {
  ApiOrganizationListType,
  getOrganizationListTypeTitle,
} from "@/types/organization-list.types.ts";
import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";

export interface OrganizationListSettingsProps {
  type: ApiOrganizationListType;
}

function trackOrganizationListViewed(type: ApiOrganizationListType) {
  switch (type) {
    case ApiOrganizationListType.termination_leave_types:
      analyticsService.trackEvent(analyticEvents.employeeTerminationLeaveTypes.viewed);
      return;
    case ApiOrganizationListType.termination_reasons:
      analyticsService.trackEvent(analyticEvents.employeeDismissalReasons.viewed);
      return;
    case ApiOrganizationListType.employee_position_change_reasons:
      analyticsService.trackEvent(analyticEvents.employeePositionChangeReasons.viewed);
      return;
    default:
      return;
  }
}

export function OrganizationListSettings({ type }: OrganizationListSettingsProps) {
  const { t } = useTranslation();
  const title = getOrganizationListTypeTitle(type, t);

  useTitle(title, t("common:settings"));

  useEffectOnce(() => {
    trackOrganizationListViewed(type);
  });

  return (
    <Page>
      <Page.Header showBack={true} title={title} navigateTo={"/settings/employment"} />
      <Page.Content className="mx-auto flex w-full max-w-4xl flex-1 flex-col pb-0">
        <OrganizationListManager type={type} showTitleField={false} stickySubmit />
      </Page.Content>
    </Page>
  );
}
